import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";

const REVIEWS = [
  { name: "Michael T.", loc: "Fredericksburg, VA", svc: "Tree Removal", stars: 5, init: "M", text: "They removed a massive oak that was leaning dangerously close to our house. The crew showed up on time, worked efficiently, and cleaned everything up perfectly. Couldn't be happier. Highly recommend Diversified Tree Services to anyone in the Fredericksburg area!" },
  { name: "Sarah L.", loc: "Stafford County, VA", svc: "Tree Trimming", stars: 5, init: "S", text: "Very professional from start to finish. They trimmed 6 trees in our backyard and it looks amazing. The team was courteous, fast, and the price was very reasonable. Will definitely use them again next season." },
  { name: "David K.", loc: "Spotsylvania, VA", svc: "Stump Grinding", stars: 5, init: "D", text: "Had two stumps ground down that had been eyesores for years. They were done in under an hour! Great communication, honest pricing, and the yard looks fantastic now. Top-notch service!" },
  { name: "Jennifer R.", loc: "King George, VA", svc: "Emergency Removal", stars: 5, init: "J", text: "After a bad storm took out a tree on our fence line, Diversified was out the next day. They handled everything including hauling away the debris. True emergency response professionals. Cannot thank them enough." },
  { name: "Robert M.", loc: "Culpeper, VA", svc: "Tree Removal", stars: 5, init: "R", text: "Free estimate was fast and accurate, no hidden fees. The crew was knowledgeable and even gave tips on maintaining our remaining trees. Best tree service I've used in 20 years of homeownership." },
  { name: "Angela B.", loc: "Manassas, VA", svc: "Tree Trimming", stars: 5, init: "A", text: "Marcus and his team are incredible. They pruned our massive oak and it looks better than it ever has. They took the time to explain exactly what they were doing and why. Real professionals." },
  { name: "Tom H.", loc: "Woodbridge, VA", svc: "Tree Removal", stars: 5, init: "T", text: "Had a dead pine that was extremely close to our deck. They used rigging to lower every piece safely without touching the deck. Truly impressive skill and professionalism. Highly recommend!" },
  { name: "Lisa P.", loc: "Warrenton, VA", svc: "Stump Grinding", stars: 5, init: "L", text: "3 stumps ground in about 2 hours. Clean, fast, and very affordable. The wood chips were spread as mulch around our garden. Wonderful job and great people to work with." },
  { name: "Carlos N.", loc: "Dumfries, VA", svc: "Tree Removal", stars: 4, init: "C", text: "Good service overall. They showed up on time and got the job done. Only minor issue was some cleanup items missed, but they came back and handled it right away. Would still use them again." },
];

export default function ReviewsPage() {
  return (
    <>
      <Header />
      <main>
        <section className="py-20 bg-[#1a3a2e] text-center">
          <div className="max-w-4xl mx-auto px-4">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">Customer Reviews</span>
            <h1 className="text-5xl font-black text-white mb-4">What Our Customers Say</h1>
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="flex gap-1">
                {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-yellow-400 text-xl"></i>)}
              </div>
              <span className="text-white text-xl font-black">4.9 / 5</span>
              <span className="text-white/60">— 200+ Google Reviews</span>
            </div>
          </div>
        </section>

        <section className="py-20 bg-[#f8f6f3]">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {REVIEWS.map((r) => (
                <div key={r.name} className="bg-white rounded-2xl p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#e8632a] rounded-full font-black text-white flex-shrink-0">
                        {r.init}
                      </div>
                      <div>
                        <p className="font-bold text-[#1e1e1e] text-sm">{r.name}</p>
                        <p className="text-gray-400 text-xs">{r.loc}</p>
                      </div>
                    </div>
                    <span className="text-[#e8632a] text-xs font-bold bg-[#e8632a]/10 px-2 py-1 rounded-full whitespace-nowrap">{r.svc}</span>
                  </div>
                  <div className="flex gap-0.5 mb-3">
                    {[...Array(r.stars)].map((_, i) => <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>)}
                    {r.stars < 5 && [...Array(5 - r.stars)].map((_, i) => <i key={`e${i}`} className="ri-star-line text-gray-300 text-sm"></i>)}
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">"{r.text}"</p>
                  <div className="flex items-center gap-1.5 mt-4 pt-3 border-t border-gray-100">
                    <i className="ri-google-fill text-gray-400 text-xs"></i>
                    <span className="text-gray-400 text-xs">Verified Google Review</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-14">
              <p className="text-gray-500 mb-6">Happy with our service? Leave us a review on Google!</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://g.page/r" target="_blank" rel="nofollow noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-[#e8632a] text-[#e8632a] font-bold rounded-lg uppercase tracking-wide hover:bg-[#e8632a] hover:text-white transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-google-fill"></i>Leave a Review
                </a>
                <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 bg-[#e8632a] text-white font-bold rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap">
                  Get a Free Estimate
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
